module.exports = __webpack_public_path__ + "img/leadercoach-poster.2475569d.jpg";